import { Component, Input } from '@angular/core';
import { HouseFlat } from '../../models/house-flat.model';
import { Tag } from '../../models/tag.model';
import { FormGroup, Validators } from '@angular/forms';
import { DataFormModel } from '../../models/data-form-model.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TagService } from '../../services/tag.service';
import { UtilService } from '../../services/util.service';
import { TagTypeService } from '../../services/tag-type.service';

@Component({
  selector: 'app-tag-modal',
  templateUrl: './tag-modal.component.html',
  styleUrl: './tag-modal.component.scss'
})
export class TagModalComponent {

  @Input() neighborhoodId: string = '';
  @Input() houseFlat?: HouseFlat;
  @Input() tag?: Tag;

  public dataForm: DataFormModel = {
    tagTypeId: {
      value: null,
      type: 'select',
      idSelect: 'tagTypeId',
      labelSelect: 'description',
      imageSelect: true,
      data: [],
      label: 'Tipo de tag',
      placeholder: 'Seleccione el tipo de tag',
      requiredMessage: 'Por favor, seleccione el tipo de tag',
      required: true,
      validators: [Validators.required]
    },
    id: {
      value: '',
      type: 'text',
      label: 'ID del tag',
      requiredMessage: 'Por favor, ingrese el ID del tag',
      required: true,
      validators: [Validators.required]
    },
    status: {
      value: true,
      type: 'switch',
      label: '¿Activo?',
      requiredMessage: '',
      required: false,
      validators: []
    },
    notes: {
      value: '',
      type: 'textarea',
      label: 'Notas',
      requiredMessage: '',
      required: false,
      validators: []
    }
  };

  public formTag!: FormGroup;
  public submitted: boolean = false;
  public loading: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    public tagService: TagService,
    public tagTypeService: TagTypeService,
    public utilService: UtilService
  ) {}

  ngOnInit(): void {
    this.loadData();
  }

  get f() {
    return this.formTag.controls;
  }

  async loadData() {
    this.loading = true;

    await this.tagTypeService.getAll();

    console.log(this.tagTypeService.tagTypes);
    

    this.dataForm['tagTypeId'].data = this.tagTypeService.tagTypes;

    if (this.tag) {
      this.dataForm = {
        ...this.dataForm
      };

      for (let key of Object.keys(this.dataForm)) {
        if (key in this.tag!) {
          const standardKey = key as keyof typeof this.tag;
          this.dataForm[key].value = this.tag[standardKey]!;
        }
      }
    }

    this.formTag = this.utilService.buildForm(this.dataForm);
    this.loading = false;
  }

  async onSubmit() {
    this.submitted = true;

    if (this.formTag.invalid) {
      return;
    }

    if (this.tag) {
      await this.update();
    } else {
      await this.create();
    }
  }

  async create() {
    const flag = await this.tagService.create(
      this.neighborhoodId,
      this.houseFlat!,
      this.formTag.value
    );

    if (flag) {
      for (let key of Object.keys(this.dataForm)) {
        this.dataForm[key].value = '';
      }

      this.activeModal.close();
    }
  }

  async update() {
    this.formTag.value.tagId = this.tag!.tagId;

    const flag = await this.tagService.update(
      this.neighborhoodId,
      this.houseFlat!,
      this.formTag.value
    );

    if (flag) {
      for (let key of Object.keys(this.dataForm)) {
        this.dataForm[key].value = '';
      }

      this.activeModal.close();
    }
  }

}
